'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTestimonialSidebarByCountry = exports.EXPERIMENT_PARAMETER_VERSION_OPTIONS = exports.EXPERIMENT_PARAMETER_VERSION_VARIANT = exports.EXPERIMENT_PARAMETER_VERSION_CONTROL = exports.EXPERIMENT_PARAMETER_VERSION = exports.EXPERIMENT_IDENTIFIER = undefined;

var _memoize = require('hs-lodash/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

var _laboratoryClient = require('laboratory-client');

var _laboratoryLib = require('laboratory-lib');

var _AnalyticsActions = require('../../actions/AnalyticsActions');

var _Utils = require('../Utils');

var _isFunnel = require('../../utils/isFunnel');

var _isFunnel2 = _interopRequireDefault(_isFunnel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EXPERIMENT_IDENTIFIER = exports.EXPERIMENT_IDENTIFIER = 'acquisition-acq065';
var EXPERIMENT_PARAMETER_VERSION = exports.EXPERIMENT_PARAMETER_VERSION = 'version';
var EXPERIMENT_PARAMETER_VERSION_CONTROL = exports.EXPERIMENT_PARAMETER_VERSION_CONTROL = 'control';
var EXPERIMENT_PARAMETER_VERSION_VARIANT = exports.EXPERIMENT_PARAMETER_VERSION_VARIANT = 'variant';
var EXPERIMENT_PARAMETER_VERSION_OPTIONS = exports.EXPERIMENT_PARAMETER_VERSION_OPTIONS = [EXPERIMENT_PARAMETER_VERSION_CONTROL, EXPERIMENT_PARAMETER_VERSION_VARIANT];

var getTestimonialSidebarByCountry = exports.getTestimonialSidebarByCountry = (0, _memoize2.default)(function () {
  var parameter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EXPERIMENT_PARAMETER_VERSION;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : EXPERIMENT_PARAMETER_VERSION_OPTIONS;

  return new Promise(function (resolve, reject) {
    if ((0, _Utils.experimentsEnabled)() && (0, _Utils.isSignupFunnelAllowed)([_isFunnel2.default.crm()])) {
      var identifier = (0, _Utils.generateRandomIdentifier)(EXPERIMENT_IDENTIFIER);

      (0, _laboratoryClient.fetchTreatment)({
        key: EXPERIMENT_IDENTIFIER,
        identifier: identifier
      }).then(function (treatment) {
        return treatment.parameters;
      }).catch(reject).then(function (parameters) {
        var p = (0, _laboratoryLib.getParameter)(parameters, parameter, options);

        resolve({
          value: p.value,
          identifier: identifier,
          parameters: parameters
        });

        return p;
      }).then(function (p) {
        if (p.isAssigned) {
          var exposure = EXPERIMENT_IDENTIFIER + '-' + p.key + '-' + p.value;
          (0, _AnalyticsActions.trackInteraction)(exposure);
        }

        return p.value;
      }).done();
    } else {
      resolve({
        value: EXPERIMENT_PARAMETER_VERSION_CONTROL
      });
    }
  });
});

exports.default = getTestimonialSidebarByCountry;